<template>
  <section class="hero-section text-white d-flex align-items-center justify-content-center">
    <div class="hero-content text-center">
      <h1 class="display-3 fw-bold">Bienvenue chez Bébé Bulle</h1>
      <p class="lead my-4">
        Un lieu chaleureux et sécurisant où chaque enfant peut s'épanouir à son rythme.
      </p>
      <a href="#formulaire" class="btn btn-primary btn-lg">
        Faire une pré-inscription
      </a>
    </div>
  </section>
</template>

<script setup lang="ts">
// This component is purely visual, no JavaScript needed here.
</script>

<style scoped>
.hero-section {
  height: 70vh; /* Section takes 70% of viewport height */
  min-height: 400px;
  position: relative; /* Required for ::before pseudo-element */
  background-color: #6c757d; /* Fallback color if image fails to load */

  /* Make sure to have a nice photo in src/assets/ */
  /*  */
  background-image: url('@/assets/creche-background.jpg');
  background-size: cover;
  background-position: center;
}

/* This element creates a dark overlay on the background image.
  It makes the white text much more readable.
*/
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
}

.hero-content {
  position: relative; /* To ensure content stays ABOVE the black overlay */
  z-index: 2;
  max-width: 800px;
  padding: 0 1rem; /* Adds some spacing on sides for mobile */
}

/* Using a more impactful font for the title */
.hero-content h1 {
  font-family: 'Poppins', sans-serif;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* Drop shadow to improve readability */
}
</style>
